import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ComplexValue, ValidationLevel, ValidationMessage } from 'ui';
import { TextConfigurationItemTranslation, TextConfigurationItem, TextItemValidation } from '../types-store';

export const validateTextItem = (
  textItem: TextConfigurationItem,
  languageOptions: ComplexValue<number>[],
  validationErrorMessage: string
): TextItemValidation => {

  const allTranslations = (languageOptions || [])
    .map(option => (textItem && textItem.translations || [])
      .find(language => language.language === option.value)
      || { language: option.value } as TextConfigurationItemTranslation
    );

  const textValidation = allTranslations
    .map(language =>
      language.text === undefined || language.text.trim() === ''
        ? {
          level: ValidationLevel.error,
          message: validationErrorMessage,
          parameters: {
            text: language.language
          }
        } as ValidationMessage
        : undefined
    )
    .filter(validation => !!validation);

  const textSetValidation = !isDefinedIncludingZero(textItem?.textSet?.value)
    ? {
      level: ValidationLevel.error,
      message: validationErrorMessage
    }
    : undefined;

  return {
    ...(textValidation.length > 0 && {
      language: {
        level: ValidationLevel.error,
        messages: textValidation
      }
    }),
    ...(!!textSetValidation && {
      textSet: {
        level: ValidationLevel.error,
        messages: [textSetValidation]
      }
    })
  };
};
